import { createFileRoute } from '@tanstack/react-router';
import { S4AlertDetail } from '@/screens/S4AlertDetail/S4AlertDetail';
import { useApiClients } from '@/app/ApiProvider';

export const Route = createFileRoute('/$orgId/alerts/$id')({
  component: AlertScreen,
});

function AlertScreen() {
  const { id } = Route.useParams();
  const clients = useApiClients();
  return <S4AlertDetail alertId={id} clients={clients} />;
}
